@if (alternates.error()) {
  <ideal-error [error]="alternates.error()"></ideal-error>
} @else {
  <ideal-product-alternates-view [alternates]="alternateItems()"></ideal-product-alternates-view>
}
